// V2 Modal - Re-export from seeds-react-modal for optimal tree shaking
export {
  Modal,
  ModalDescription,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseWrapper,
  ModalRail,
  ModalAction,
  ModalCustomHeader,
  ModalCustomFooter,
  useModalExternalTrigger,
} from "@sproutsocial/seeds-react-modal/v2";

// Explicit type exports
export type {
  TypeModalProps,
  TypeModalHeaderProps,
  TypeModalFooterProps,
  TypeModalBodyProps,
  TypeModalDescriptionProps,
  TypeModalRailProps,
  TypeModalActionProps,
  ModalCloseWrapperProps,
} from "@sproutsocial/seeds-react-modal/v2";

// Explicit constant exports
export {
  DEFAULT_MODAL_WIDTH,
  DEFAULT_MODAL_BG,
  BODY_PADDING,
  MODAL_SIZE_PRESETS,
} from "@sproutsocial/seeds-react-modal/v2";
